module.exports = __webpack_public_path__ + "static/media/helix-hx7.0b4e0cf3.png";